<div [style]="style"></div>
